















































































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import SelectProject from '@/components/selectProject.vue';
import { FormModel } from 'ant-design-vue';
import { convertTreeDataToCategory, generateTreeData, IForm, ITreeData, todoTypeManage } from '../todoType';
import { generateUUID } from '@/utils/other';

type ITodoTypeRow = ITodo.ITodoTypeRow;

@Component({
  components: {
    SelectProject,
  },
})
export default class TodoTypeModal extends Vue {
  @Ref() private readonly editTodoTypeForm!: FormModel;
  private visible = false;
  private loading = false;
  private title = this.$t('form.create');
  private form: IForm = {
    name: '',
    active: true,
    projectId: '',
    projectName: '',
  };
  private rules = {
    name: [
      {
        required: true,
        message: () => this.$t('form.required'),
        trigger: 'blur',
      },
    ],
    projectId: [
      {
        required: true,
        message: () => this.$t('form.required'),
        trigger: 'change',
      },
    ],
  };
  private categoryTreeData: ITreeData[] = [];
  private todoTypeRow: ITodoTypeRow | null = null;
  public showModal(todoTypeRow: ITodoTypeRow, isCreate: boolean) {
    this.todoTypeRow = todoTypeRow;
    this.visible = true;
    this.title = isCreate ? this.$t('form.create') : this.$t('form.edit');
    this.initFormData(todoTypeRow);
    this.initCategoryTreeData(todoTypeRow, isCreate);
  }
  private initFormData(todoTypeRow: ITodoTypeRow) {
    this.form = {
      name: todoTypeRow.name,
      active: todoTypeRow.active,
      projectId: todoTypeRow.projectId,
      projectName: todoTypeRow.projectName,
    };
  }
  private initCategoryTreeData(todoTypeRow: ITodoTypeRow, isCreate: boolean) {
    if (isCreate) {
      this.categoryTreeData = generateTreeData([todoTypeRow], todoTypeRow);
    } else {
      this.categoryTreeData = generateTreeData(todoTypeManage.tableData, todoTypeRow);
    }
  }
  private handleProjectChange(projectInfo: IProject.IResponse.IProjectInfo) {
    if (projectInfo) {
      this.form.projectId = projectInfo.id;
      this.form.projectName = projectInfo.name;
    } else {
      this.form.projectId = '';
      this.form.projectName = '';
    }
  }
  private addChildren(key: string) {
    const addChildren = (data: ITreeData[], targetKey: string) => {
      for (const item of data) {
        if (item.key === targetKey) {
          item.children.push({
            name: '',
            position: `${item.position}-${item.children.length}`,
            key: generateUUID(),
            value: null,
            children: [],
            formatType: 0,
          });
          break;
        } else {
          addChildren(item.children, targetKey);
        }
      }
    };
    addChildren(this.categoryTreeData, key);
  }
  private addTopCategoryTreeData() {
    const position = this.categoryTreeData.length.toString();
    this.categoryTreeData.push({
      name: '',
      position,
      key: generateUUID(),
      value: null,
      children: [],
      formatType: 0,
    });
  }
  private deleteChild(key: string) {
    const deleteChild = (data: ITreeData[], deleteKey: string) => {
      for (let index = 0; index < data.length; index++) {
        if (data[index].key === deleteKey) {
          data.splice(index, 1);
          break;
        } else {
          deleteChild(data[index].children, key);
        }
      }
    };
    deleteChild(this.categoryTreeData, key);
  }
  private handleSubmit() {
    if (!this.todoTypeRow) {
      return;
    }
    this.editTodoTypeForm.validate((valid) => {
      if (valid) {
        this.submitTodoType();
      } else {
        return false;
      }
    });
  }
  private submitTodoType() {
    if (!this.todoTypeRow) {
      return;
    }
    const updatePosition = (data: ITreeData[], preIndex?: string) => {
      for (let index = 0; index < data.length; index++) {
        data[index].position = preIndex ? `${preIndex}-${index}` : `${index}`;
        if (data[index].children.length > 0) {
          updatePosition(data[index].children, data[index].position);
        }
      }
    };
    updatePosition(this.categoryTreeData);
    this.loading = true;
    const category = convertTreeDataToCategory(this.categoryTreeData);
    const {name, projectId, active} = this.form;
    todoTypeManage.requestUpdateTodoType({
      id: this.todoTypeRow!.id,
      data: {
        projectId,
        name,
        category,
        active,
      },
    }).then((res) => {
      this.$message.success(res);
      this.visible = false;
      this.$emit('submit');
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.loading = false;
    });
  }
}
